import $ from 'jquery'; 
window.$ = window.jQuery = $;
$(document).on("click",".delete-project", function()
{
console.log('delete file');
    if(confirm("Are you sure you want to delete this?"))
    {
        let id = $(this).data('id');
        console.log(id);
        let url = "/inventor/project/delete/" + id;

        $("#delete").attr("href", url);
        window.location.href = url;
    } 
    else 
    {
        event.preventDefault();
    }
});

$(".delete-address").click(function(event)
    {
        if(confirm("Are you sure you want to delete this?"))
        {
            let id = $(this).data('ad-id');
            console.log(id);
            let url = "/inventor/address/delete/" + id;
            console.log(url);

            $("#ad-delete").attr("href", url);
            window.location.href = url;

        }
        else
        {
                event.preventDefault();
            }
});

$(document).on('click', '.vendor-ad-delete', function(event)
{
    if(confirm("Are you sure you want to delete this?"))
    {
        let id = $(this).data('id');
        console.log(id);
        let url = "/add/vendor/delete/" + id;
        $("#delete").attr("href", url);
        window.location.href = url;
    } 
    else 
    {
        event.preventDefault();
    }
});

$(document).on('click', '.extquotedelete', function(event)
{
    let id = $(this).data('qid');
    let qtype = $(this).data('qtype');
    let msg = 'Are you sure you want to delete this?';
    let payment = $(this).data('payment');
    if(qtype == 'external' )
    {
        if(payment != 0)
        {
            msg = 'This will delete payments of $'+payment+' recorded against this RFQ and quote will be deleted. Are you sure you want to omit?';
        }
        else
        {
             msg = 'This will delete RFQ record, Are you sure you want to omit ?';

        }
    }
    if(qtype == 'internal')
    {
        if(payment != 0)
        {
            msg = 'This will also delete  payments of $'+payment+' recorded against this RFQ and status updated as Rejected. Are you sure you want to omit?';
        }
        else
        {
             msg = 'This will delete RFQ record from account managment and quote status will be change to rejected, Are you sure you want to omit ?';

        }
    }
    if(confirm(msg))
    {
        let url = "/inventor/account/data/delete/" + id + '/' + qtype;
        $("#delete").attr("href", url);
        window.location.href = url;
    } 
    else 
    {
        event.preventDefault();
    }
});

$(document).on("click",".delete-schedule", function()
{
    if(confirm("Are you sure you want to delete this?"))
    {
        let id = $(this).data('id');
        console.log(id);
        let url = "/schdule/task/delete/" + id;
        $("#delete").attr("href", url);
        window.location.href = url;
    } 
    else 
    {
        event.preventDefault();
    }
});
